import React from "react";
import { IonPage } from "@ionic/react";
import { Button, Result } from "antd";
import { useHistory } from "react-router-dom";

const Component = () => {
  const history = useHistory();

  return (
    <IonPage>
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button
            type="primary"
            onClick={() => {
              history.push("/login");
            }}
          >
            Back to Sign In
          </Button>
        }
      />
    </IonPage>
  );
};

export default Component;
